const LANDING_CDN = 'https://neoterra-site.b-cdn.net/landing%20page';

export const homeHeroPromoVideoDesktop = `${LANDING_CDN}/elmora-hero-desktop.mp4`;
export const homeHeroPromoVideoMobile = `${LANDING_CDN}/elmora-hero-mobile.mp4`;
export const humanCentredDesignDesktop = `${LANDING_CDN}/human-centred-design-slide-new-vision-desktop.webp`;
export const shot3Image = `${LANDING_CDN}/shot3.jpg`;
export const shot4Image = `${LANDING_CDN}/shot4.jpg`;
export const shot5Image = `${LANDING_CDN}/shot5.jpg`;
export const shot6Image = `${LANDING_CDN}/shot6.jpg`;
export const shot1Image = `${LANDING_CDN}/shot1.png`;
export const eiraMobileShowcaseImage = `${LANDING_CDN}/Frame_2.png`;
export const shot2Image = `${LANDING_CDN}/shot2.png`;
export const elmoraMobileShowcaseImage = `${LANDING_CDN}/elmora%20shot%202.png`;
export const asset18Image = `${LANDING_CDN}/built-with-care-garden.webp`;
export const asset19Image = `${LANDING_CDN}/masterclass-design-staircase.webp`;
export const asset01 = `${LANDING_CDN}/obsession-for-detail-interior.webp`;
export const asset20 = `${LANDING_CDN}/privilege-extraordinary-living.webp`;
